<template>
  <div>
<v-layout fill-height>
  <v-flex sm6 class="overflow-auto"><v-container>
    <v-text-field v-model="leftBaseUrl"></v-text-field>
    <v-text-field v-model="leftUrl">
      <template #append>
        <v-icon v-if="leftReady">mdi-check</v-icon>
      </template>
      <template #append-outer>
        <v-select label="Layer" v-model="leftLayer" :items="[{text: 'Base', value: ''}, {text: 'Day', value: 'day'}, {text: 'Karafarin', value: 'karafarin'}]">
        </v-select>
        <v-btn icon @click="downloadLeft"><v-icon>mdi-download</v-icon></v-btn>
      </template>
    </v-text-field>
    <v-text-field label="Def" v-model="compareRoot.defId"></v-text-field>
    <v-text-field label="Attr" v-model="compareRoot.attrName"></v-text-field>
  </v-container></v-flex>
  <v-flex sm6 class="overflow-auto"><v-container>
    <v-text-field v-model="jsonPath" label="JSONPath"></v-text-field>
    <v-text-field v-model="jmesPath" label="JMESPath"></v-text-field>
    <v-btn :disabled="!leftReady" @click="search"><v-icon>mdi-magnify</v-icon>Search</v-btn>
  </v-container></v-flex>
  <v-bottom-sheet v-model="showError" overlay-color="red" hide-overlay>
    <v-alert type="error">
      <pre>{{error}}</pre>
    </v-alert>
  </v-bottom-sheet>
</v-layout>
    <v-switch label="Table View" v-model="tableView"></v-switch>
    <v-data-table v-if="tableView" :items="jmesPathResult" :headers="Array.from(new Set(jmesPathResult.map(i => Object.keys(i)).reduce((a, v) => [...a, ...v], []))).map(n=>({text: n, value: n}))">>
      <template v-for="(prop) of Array.from(new Set(jmesPathResult.map(i => Object.keys(i)).reduce((a, v) => [...a, ...v], []))).map(p => 'item.' + p)" v-slot:[prop]="{value}">
        <div :key="prop">
        <v-textarea v-if="value && typeof(value) === 'object'" :value="JSON.stringify(value)"></v-textarea>
        <span v-else class="text-wrap" style="word-break: break-word;">{{value}}</span>
        </div>
      </template>
    </v-data-table>
    <v-data-table v-else :items="jmesPathResult.map(item => ({item}))" :headers="['item'].map(n=>({text: n, value: n}))">>
      <template v-for="(prop) of ['item'].map(p => 'item.' + p)" v-slot:[prop]="{value}">
        <div :key="prop">
        <v-textarea v-if="value && typeof(value) === 'object'" :value="JSON.stringify(value)"></v-textarea>
        <span v-else class="text-wrap" style="word-break: break-word;">{{value}}</span>
        </div>
      </template>
    </v-data-table>
  </div>
  
</template>

<script>
  import jmespath from "jmespath";

  export default {
    name: 'DefAdmin',

    async mounted() {

    },

    created() {

    },

    data: () => ({
      leftBaseUrl: "/proxy/https:day-develop.karestanjavan.ir/v1/def",
      leftUrl: "/Root/Root/$seed",
      leftLayer: '',
      jsonPath: "$..*[?(@.id)]",
      jmesPath: "{id: id}",
      tableView: false,
      types: ['Array.Left.Def', 'Attr.Diff.Value', 'Attr.Left', 'Def.Exclude.Left', 'Attr.Value.Exclude.Left', 'Def.Revert.Left', 'Attr.Value.Revert.Left', 'Attr.Right', 'Def.Exclude.Right'],
      leftRoot: null,
      rightRoot: null,
      leftReady: false,
      rightReady: false,
      compareRoot: {
        defId: "",
        attrName: ""
      },
      diffReady: false,
      downloading: false,
      jsonPathResult: [],
      jmesPathResult: [],
      vers: [],
      leftItems: [],
      selectedRows: [],
      script: "",
      selectedItem: null,
      id: {last: 0},
      active: [],
      open: [],
      attributes: [],
      items: [],
      changes: "",
      showError: false,
      _error: "",
      set error(value) {
        console.log("set error", this.showError, value)
        this.showError = true
        this._error = value;
        setTimeout(() => {
          this.showError = false;
          this._error = ""
        }, 5000)
      },
      get error() {
        return this._error;
      },
      saving: false,
      treeLoaded: false,
      paths: [],
      changed: false,
      reloading: false,
      dialog1: {
        show: false,
      },
    }),

    methods: {
      async downloadLeft() {
        this.leftReady = false
        this.leftRoot = null
        const result = await fetch(this.leftBaseUrl + this.leftUrl + (this.leftLayer ? "/$get" : ""), {
          method: this.leftLayer ? "POST" : "GET",
          headers: {
            'Content-Type': 'application/json'
          },
          body : this.leftLayer ? JSON.stringify({
            layer: {
              name: "Root",
              kind: "Root",
              attrs: [{ name: "#CompID", value: { text: this.leftLayer } }]
            }
          }) : null
        })
        if (result.ok) {
          this.leftRoot = await result.json()
          this.leftReady = true
        } else
          this.error = await result.text()

        this.populateIds(this.leftRoot)
      },

      populateIds(def) {
        function f(path, d) {
          if (d.kind) {
            d.id = name(path);
          }
          if (d.attrs && d.attrs.length) {
            for (let attr of d.attrs) {
              if (attr && attr.value) {
                const va = (attr.value.def && [attr.value] || attr.value.array || []).filter(v => v.def).map(v => v.def)
                for (let v of va) {
                  f(path.concat([attr, v]), v)
                }
              }
            }
          }
        }

        f([def], def);

        function name(path) {
          return path.slice(1).filter(p => p && p.kind).map(p => p.name).join(".")
        }
      },

      updateScript() {
        const shell = getShell(this.leftRoot, this.left.id)

        console.log({shell})
        console.log({sel: this.selectedRows})

        const diffs = this.selectedRows.map(i => this.diffs[i.id])

        for (let diff of diffs) {
          let parent = this.getDefById(this.left.id, shell)
          let array = false

          const path = diff.path.split('.').slice(1)
          for (let segment of path) {
            if (segment.startsWith('@')) {
              //parent is def
              let attr = segment.substring(1)
              array = attr.endsWith('[]')
              if (array) {
                attr = attr.substring(0, attr.length - 2)
              }
              if (!parent.attrs.some(a => a.name === attr)) {
                parent.attrs.push({name: attr, value: {}})
              }
              parent = parent.attrs.find(a => a.name === attr)
              if (array && !parent.value.array) {
                parent.value.array = []
              }
            } else {
              //parent is attr
              const name = segment.split(':')[0]
              const kind = segment.split(':')[1]
              if (array) {
                if (!parent.value.array.some(v => v.def?.name === name)) {
                  parent.value.array.push({def: {name: name, kind: kind, attrs: []}})
                }
                parent = parent.value.array.find(v => v.def?.name === name).def
              } else {
                if (parent.value.def?.name !== name) {
                  parent.value.def = {name: name, kind: kind, attrs: []}
                }
                parent = parent.value.def
              }
            }
          }

          switch (diff.type) {
            case 'Array.Left.Def':
              //parent should be attr of type array
              parent.value.array.push({def: diff.left})
              break;
            case 'Attr.Diff.Value':
            case 'Attr.Left':
              //parent should be def
              parent.attrs.push(diff.attr)
              break;
            case 'Def.Exclude.Left':
              //parent should be def
              parent.exclude = diff.left
              break;
            case 'Def.Revert.Left':
              //parent should be def
              parent.revert = diff.left
              break;
            case 'Attr.Value.Exclude.Left':
              //parent should be attr
              parent.value.exclude = diff.left
              if (!parent.value.array)
                parent.value.array = []  
              break;
            case 'Attr.Value.Revert.Left':
              //parent should be attr
              parent.value.revert = diff.left
              if (!parent.value.array)
                parent.value.array = []                
              break;
          }

        }

        this.script = JSON.stringify(shell)

        function getShell(root, id) {
          console.log({shell: root.id, id})

          const shell = {name: root.name, kind: root.kind, id: root.id, attrs: []}

          if (root.id === id)
            return shell

          shell.attrs = shell.attrs.concat(
              root.attrs.filter(a => a.value?.def && id.match(`^${a.value.def.id}(\\..+|$)`))
                  .map(a => ({...a, value: {def: getShell(a.value.def, id)}})))

          shell.attrs = shell.attrs.concat(
              root.attrs.filter(a => a.value?.array)
                  .map(a => ({
                    ...a,
                    value: {array: a.value.array.filter(av => av.def && id.match(`^${av.def.id}(\\..+|$)`)).map(av => ({def: getShell(av.def, id)}))}
                  }))
                  .filter(a => a.value.array.length)
          )

          return shell
        }
      },

      async downloadRight() {
        this.rightReady = false;
        this.rightRoot = null
        const result = await fetch(this.rightUrl)
        if (result.ok) {
          this.rightRoot = await result.json()
          this.rightReady = true
        } else
          this.error = await result.text()

        this.populateIds(this.rightRoot)
      },

      async downloadLeftVers() {
        this.downloading = true
        try {
          const vers = this.diffs.map(item => item.left && item.left.ver || item.leftDef && item.leftDef.ver).filter(v => v)
          const minVer = Math.min(...vers)
          const maxVer = Math.max(...vers)
          this.vers = await Promise.all(
              Array.from({length: maxVer - minVer + 1}, (v, k) => k + minVer)
                  .map(async v => await fetch(this.leftBaseUrl + `/${v}`)
                      .then(r => r.json())))
        } finally {
          this.downloading = false
        }
      },

      compact(def) {
        if (!def) 
          return def;
        
        return compactDef(def)
        
        function compactDef(def) {
          return {
            ...({...def, attrs: null}),
            ...compactAttrs(def.attrs)
          }
        }
        
        function compactAttrs(attrs) {
          return attrs.reduce((a, v) => ({...a, [v.name]: compactAttrValue(v.value)}), {})
        }

        function compactAttrValue(attrValue) {
          return attrValue.array ? attrValue.array.map(compactAttrValue)
              : attrValue.def ? compactDef(attrValue.def) 
              : attrValue.ref || attrValue.text || attrValue.number || attrValue.bool 
        }
      },

      flattenDef(def, path, list) {
        function explode(def) {
          return def.exclude || def.revert || def.base?.ref || def.attrs?.some(a => a.value?.def && explode(a.value?.def) || a.value?.array?.some(v => v.def))
        }

        if (!explode(def)) {
          list.push({op: 'def', path, value: def})
          return
        }
        if (def.exclude)
          list.push({op: 'exclude', path, value: def.exclude})
        if (def.revert)
          list.push({op: 'revert', path, value: def.revert})
        if (def.base?.ref)
          list.push({op: 'base', path, value: def.base.ref})
        for (const attr of def.attrs || []) {
          this.flattenAttr(attr, path, list)
        }
      },

      flattenAttr(attr, path, list) {
        if (attr.exclude)
          list.push({op: 'exclude', path: path + '.@' + attr.name, value: attr.exclude})
        if (attr.revert)
          list.push({op: 'revert', path: path + '.@' + attr.name, value: attr.revert})

        if (attr.value?.array?.length) {
          this.flattenArray(attr.value.array, path + '.@' + attr.name + "[]", list);
        }

        if (attr.value?.def) {
          this.flattenDef(attr.value.def, path + '.@' + attr.name, list);
        }

        if (attr.value?.ref || this.valueValue(attr.value) != null) {
          list.push({op: 'value', path: path + '.@' + attr.name, value: attr.value})
        }
      },

      flattenArray(array, path, list) {
        for (const l of array) {
          if (l.def) {
            this.flattenDef(l.def, path + "." + l.def.name, list)
          } else if (l.ref || this.valueValue(l) != null) {
            list.push({op: 'value', path: path, value: l.value})
          }
        }
      },

      async search() {
        try {
          console.log({leftRoot: this.leftRoot})

          this.left = this.compact(this.getDefById(this.compareRoot.defId, this.leftRoot))

          console.log({left: this.left})

          // const jsonpath = require('jsonpath')

          // const query = (n,p) => jsonpath.query(n, p)
 
          const {JSONPath} = require('jsonpath-plus');

          const query = (n, p) => JSONPath({path: p, json: n})

          const pathResult = query(this.left, this.jsonPath)

          this.jsonPathResult = pathResult && (pathResult.length ? pathResult : [pathResult])

          console.log({jsonPathResult: this.jsonPathResult})

          if (!this.jmesPath) {
            this.jmesPathResult = this.jsonPathResult
            return
          }

          this.jmesPathResult = this.jsonPathResult.map(r => jmespath.search(r, this.jmesPath))

          console.log({jmesPathResult: this.jmesPathResult})

          console.log(Array.from(new Set(this.jmesPathResult.map(i => Object.keys(i)).reduce((a, v) => [...a, ...v], []))))
        } catch(err) {
          this.error = err
        }
      },

      getDefById(id, d) {
        if (d.id === id)
          return d;

        if (d.attrs && d.attrs.length) {
          for (let attr of d.attrs) {
            if (attr && attr.value) {
              const va = (attr.value.def && [attr.value] || attr.value.array || []).filter(v => v.def).map(v => v.def)
              for (let v of va) {
                const r = this.getDefById(id, v)
                if (r)
                  return r;
              }
            }
          }
        }
      },

      toItemDef(def, parent) {
        const id = (parent ? parent.id + "/" : "") + def.name
        const node = {
          parent,
          def,
          id,
          name: def.name,
        }

        node.children = this.defNodeChildren(node) || []

        node.diffs = this.diffs.filter(d => d.array && d.array === parent?.attr?.value?.array && (d.left?.def || d.left) === node.def)

        node.diffs.push(...this.diffs.filter(d => d.array && d.array === parent?.attr?.value?.array && (d.right?.def || d.right) === node.def))

        node.diffs.push(...this.diffs.filter(d => d.def && d.def === parent?.def && d.left?.value?.def === node.def))

        node.diffs.forEach(d => d.found = true)

        if (node.diffs.length) {
          for (const c of node.children)
            c.parentDiff = true
        }

        if (parent)
          parent.childrenDiffs ||= node.diffs.length || node.childrenDiffs

        if (parent && !node.diffs.length && !node.childrenDiffs)
          return null

        return node
      },

      defNodeChildren(node) {
        return node.def.attrs?.map(a => this.toItemAttr(a, node)).filter(node => node)
      },

      toItemAttr(attr, parent) {
        if (attr.value?.def) {
          return this.toItemDef(attr.value.def, parent)
        }

        const id = (parent ? parent.id + "/" : "") + '@' + attr.name
        const node = {
          parent,
          attr,
          id,
          name: attr.name,
        }

        const missing = this.diffs.filter(d => d.array && d.array === attr.value?.array && d.left == null).map(d => d.right)

        node.children = (node.attr.value?.array ?? []).concat(missing).map(v => this.toItemAttrValue(v, node)).filter(node => node)

        node.diffs = this.diffs.filter(d => d.attr === attr || d.left === attr)

        node.diffs.forEach(d => d.found = true)

        if (node.diffs.length) {
          for (const c of node.children)
            c.parentDiff = true
        }

        if (parent)
          parent.childrenDiffs ||= node.diffs.length || node.childrenDiffs

        if (!node.diffs.length && !node.childrenDiffs)
          return null

        return node
      },

      toItemAttrValue(v, parent) {
        if (v.def)
          return this.toItemDef(v.def, parent)

        console.log(v)
      },

      compareDef(left, right, path, attrName) {
         if (left.base?.kind !== right.base?.kind || left.base?.name !== right.base?.name) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Base", left: left.base, right: right.base, path})
        }

        const leftExclude = (left.exclude ?? []).filter(e => !right.exclude?.includes(e))
        const rightExclude = (right.exclude ?? []).filter(e => !left.exclude?.includes(e))
        
        if (leftExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Exclude.Left", left: leftExclude, path})
        }

        if (rightExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Exclude.Right", right: rightExclude, path})
        }

        const leftRevert = (left.revert ?? []).filter(e => !right.revert?.includes(e))
        const rightRevert = (right.revert ?? []).filter(e => !left.revert?.includes(e))

        if (leftRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Revert.Left", left: leftRevert, path})
        }

        if (rightRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Def.Revert.Right", right: rightRevert, path})
        }
        
        for (const leftAttr of left.attrs || []) {
          if (attrName && leftAttr.name !== attrName)
            continue

          const rightAttr = (right.attrs || []).find(a => a.name === leftAttr.name)
          if (!rightAttr) {
            this.diffs.push({
              leftDef: left,
              def: left,
              type: "Attr.Left",
              attr: leftAttr,
              left: leftAttr.value,
              right: null,
              path
            })
          } else {
            this.compareAttr(leftAttr, rightAttr, path, left)
          }
        }

        for (const rightAttr of right.attrs || []) {
          if (attrName && rightAttr.name !== attrName)
            continue

          const leftAttr = (left.attrs || []).find(a => a.name === rightAttr.name)
          if (!leftAttr) {
            this.diffs.push({
              leftDef: left,
              def: left,
              type: "Attr.Right",
              attr: rightAttr,
              left: null,
              right: rightAttr.value,
              path
            })
          }
        }
      },

      compareAttr(left, right, path, leftDef) {
        const leftExclude = (left.value?.exclude ?? []).filter(e => !right.value?.exclude?.includes(e))
        const rightExclude = (right.value?.exclude ?? []).filter(e => !left.value?.exclude?.includes(e))

        if (leftExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Exclude.Left", left: leftExclude, path: path + '.@' + left.name})
        }

        if (rightExclude.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Exclude.Right", right: rightExclude, path: path + '.@' + left.name})
        }

        const leftRevert = (left.value?.revert ?? []).filter(e => !right.value?.revert?.includes(e))
        const rightRevert = (right.value?.revert ?? []).filter(e => !left.value?.revert?.includes(e))

        if (leftRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Revert.Left", left: leftRevert, path: path + '.@' + left.name})
        }

        if (rightRevert.length) {
          this.diffs.push({leftDef: left, def: left, type: "Attr.Value.Revert.Right", right: rightRevert, path: path + '.@' + left.name})
        }

        if (left.value?.array?.length) {
          if (!right.value?.array?.length)
            this.diffs.push({leftDef, attr: left, type: "Attr.Left.Array", left: left.value.array, right: null, path})
          else
            this.compareArray(left.value.array, right.value.array, path + '.@' + left.name + "[]", leftDef);
        }

        if (left.value?.def) {
          if (!right.value?.def)
            this.diffs.push({attr: left, type: "Attr.Left.Def", left: left.value.def, right: null, path})
          else
            this.compareDef(left.value.def, right.value.def, path + '.@' + left.name + '.' + left.value.def.name + ':' + left.value.def.kind);
        }

        if (left.value?.ref) {
          if (!right.value?.ref)
            this.diffs.push({leftDef, attr: left, type: "Attr.Left.Value", left: left.value, right: null, path})
          else if (left.value.ref.kind !== right.value.ref.kind || left.value.ref.name !== right.value.ref.name)
            this.diffs.push({
              leftDef,
              attr: left,
              type: "Attr.Diff.Value",
              left: left.value,
              right: right.value.ref,
              path
            })
        }

        if (this.valueValue(left.value) != null) {
          if (this.valueValue(right.value) == null)
            this.diffs.push({leftDef, attr: left, type: "Attr.Left.Value", left: left.value, right: null, path})
          else if (this.valueValue(left.value) !== this.valueValue(right.value))
            this.diffs.push({leftDef, attr: left, type: "Attr.Diff.Value", left: left.value, right: right.value, path})
        }

        if (right.value?.array?.length && !left.value?.array?.length) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Array", left: null, right: right.value.array, path})
        }

        if (right.value?.def && !left.value?.def) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Def", left: null, right: right.value.def, path})
        }

        if (right.value?.ref && !left.value?.ref) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Value", left: null, right: right.value, path})
        }

        if (this.valueValue(right.value) != null && this.valueValue(left.value) == null) {
          this.diffs.push({leftDef, attr: left, type: "Attr.Right.Value", left: null, right: right.value, path})
        }
      },

      compareArray(left, right, path, leftDef) {
        for (const l of left) {
          if (l.def) {
            const r = right.find(v => v.def?.kind === l.def.kind && v.def?.name === l.def.name)
            if (!r)
              this.diffs.push({array: left, type: "Array.Left.Def", left: l.def, right: null, path})
            else
              this.compareDef(l.def, r.def, path + "." + l.def.name + ':' + l.def.kind)
          } else if (l.ref) {
            const r = right.find(v => v.ref?.kind === l.ref.kind && v.ref?.name === l.ref.name)
            if (!r)
              this.diffs.push({leftDef, array: left, type: "Array.Left.Value", left: l, right: null, path})
          } else if (this.valueValue(l) != null) {
            const r = right.find(v => this.valueValue(v) === this.valueValue(l))
            if (!r)
              this.diffs.push({leftDef, array: left, type: "Array.Left.Value", left: l, right: null, path})
          }
        }
        for (const r of right) {
          if (r.def && !left.find(v => v.def?.kind === r.def.kind && v.def?.name === r.def.name))
            this.diffs.push({leftDef, array: left, type: "Array.Right.Def", left: null, right: r.def, path})
          else if (r.ref && !left.find(v => v.ref?.kind === r.ref.kind && v.ref?.name === r.ref.name))
            this.diffs.push({leftDef, array: left, type: "Array.Right.Value", left: null, right: r, path})
          else if (this.valueValue(r) != null && !left.find(v => this.valueValue(v) !== this.valueValue(r)))
            this.diffs.push({leftDef, array: left, type: "Array.Right.Value", left: null, right: r, path})
        }
      },

      valueValue(v) {
        return v?.text != null ? v.text : v?.number != null ? v.number : v?.bool != null ? v.bool : null
      },
    }
  }
</script>
